/**
 * 丝滑滚动驱动文字向上渐显 + 渐变流动效果 (支持来回滚动重置)
 */

(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  // 配置参数
  const CONFIG = {
    triggerOffset: 0.2,         // 触发位置：元素顶部进入视口 20% 处开始动画
    staggerDelay: 100,          // 元素间交错延迟 (ms)
    gradientSpeed: 0.4,         // 渐变流动速度系数
    resetThreshold: 50          // 离开视口多少像素后重置 (防止边缘闪烁)
  };

  // 存储每个元素的动画状态，防止重复创建定时器
  const elementStates = new Map();

  /**
   * 获取当前需要动画的所有元素
   * 根据屏幕宽度动态选择桌面或移动端容器
   */
  function getTargetElements() {
    const isDesktop = window.innerWidth >= 1024;
    const containerId = isDesktop ? 'wheel_display_comparison_about_us' : 'wheel_display_comparison_about_us_mobile';
    const container = document.getElementById(containerId);

    if (!container) return [];

    // 返回带有 wheel-animate-item 类的元素
    return Array.from(container.querySelectorAll('.wheel-animate-item'));
  }

  /**
   * 检查元素是否应该显示
   * 逻辑：元素顶部进入视口一定比例，且底部未完全离开视口
   */
  function shouldShowElement(el) {
    const rect = el.getBoundingClientRect();
    const vh = window.innerHeight;

    // 触发点：视口高度 * (1 - offset)
    const triggerPoint = vh * (1 - CONFIG.triggerOffset);

    // 条件1: 元素顶部已到达触发点
    const hasEntered = rect.top <= triggerPoint;
    // 条件2: 元素底部还未完全离开视口上方 (留一点缓冲防止快速滚动时瞬间重置)
    const hasNotLeft = rect.bottom > -CONFIG.resetThreshold;

    return hasEntered && hasNotLeft;
  }

  /**
   * 处理单个元素的显示/隐藏/渐变逻辑
   */
  function handleElementAnimation(el, index) {
    const isVisible = shouldShowElement(el);
    const currentState = elementStates.get(el) || { visible: false, timerId: null };

    if (isVisible && !currentState.visible) {
      // --- 状态改变：从 隐藏 -> 显示 ---

      // 1. 添加 visible 类 (触发 CSS transition: 上浮 + 淡入)
      // 使用 setTimeout 实现交错效果 (Stagger)
      currentState.timerId = setTimeout(() => {
        el.classList.add('visible');

        // 2. 如果是移动端且有渐变背景，启动渐变流动动画
        if (el.classList.contains('mobile-gradient-text')) {
          startGradientFlow(el);
        }

        // 更新状态
        elementStates.set(el, { visible: true, timerId: null });
      }, index * CONFIG.staggerDelay);

      elementStates.set(el, { ...currentState, timerId: currentState.timerId });

    } else if (!isVisible && currentState.visible) {
      // --- 状态改变：从 显示 -> 隐藏 (重置) ---

      // 1. 清除之前的延时器 (如果用户滚动太快，元素还没完全显示就回去了)
      if (currentState.timerId) {
        clearTimeout(currentState.timerId);
      }

      // 2. 移除 visible 类 (触发 CSS transition: 下沉 + 淡出)
      el.classList.remove('visible');

      // 3. 重置渐变背景位置 (立即重置或过渡重置，这里选择立即重置以配合下一次动画)
      if (el.classList.contains('mobile-gradient-text')) {
        stopGradientFlow(el);
        el.style.backgroundPosition = '0% 0%';
      }

      // 4. 更新状态
      elementStates.set(el, { visible: false, timerId: null });
    }

    // 如果保持可见，持续更新渐变位置 (让流动效果跟随滚动微调，可选)
    if (isVisible && currentState.visible && el.classList.contains('mobile-gradient-text')) {
      // 这里可以根据 scrollY 做更精细的背景位置微调，目前由 startGradientFlow 的自动播放处理即可
      // 若需严格跟随滚动进度，可在此处计算 progress 并赋值 backgroundPosition
    }
  }

  /**
   * 启动渐变流动效果
   */
  function startGradientFlow(el) {
    // 清除可能存在的旧定时器
    if (el._gradientInterval) clearInterval(el._gradientInterval);

    let progress = 0;
    el._gradientInterval = setInterval(() => {
      progress += 0.015; // 流动速度
      if (progress >= 1) {
        progress = 1;
        clearInterval(el._gradientInterval);
        el._gradientInterval = null;
      }
      // 移动背景位置：0% -> 100%
      el.style.backgroundPosition = `${progress * 100 * CONFIG.gradientSpeed}% 0%`;
    }, 20);
  }

  /**
   * 停止渐变流动并清理
   */
  function stopGradientFlow(el) {
    if (el._gradientInterval) {
      clearInterval(el._gradientInterval);
      el._gradientInterval = null;
    }
  }

  /**
   * 主滚动循环 (使用 requestAnimationFrame 保证丝滑)
   */
  let ticking = false;

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(() => {
        const elements = getTargetElements();

        // 遍历所有元素，根据当前位置决定显示或重置
        elements.forEach((el, index) => {
          handleElementAnimation(el, index);
        });

        ticking = false;
      });
      ticking = true;
    }
  }

  /**
   * 初始化
   */
  function init() {
    // 绑定滚动事件 (passive: true 提升性能)
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => {
      // 窗口大小变化时，强制重置所有状态，防止错位
      elementStates.clear();
      const allItems = document.querySelectorAll('.wheel-animate-item');
      allItems.forEach(el => {
        el.classList.remove('visible');
        stopGradientFlow(el);
        el.style.backgroundPosition = '0% 0%';
      });
      // 立即执行一次检查
      onScroll();
    });

    // 初始检查 (防止页面加载时元素已在视口内)
    onScroll();
  }

  // 启动
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

/**
 * 加粗前两个字符的函数 (保持原有功能)
 */
function boldFirstTwoChars() {
  const elements = document.querySelectorAll('.font2_font');
  elements.forEach(el => {
    if (el.querySelector('span')) return; // 避免重复处理
    const text = el.textContent || '';
    if (text.length <= 2) return;

    const firstTwo = text.slice(0, 2);
    const rest = text.slice(2);

    // 使用 inherit 继承父级的颜色 (无论是白色还是渐变透明)
    el.innerHTML = `<span style="font-weight: 900; color: inherit;">${firstTwo}</span>${rest}`;
  });
}

// 页面加载完成后执行加粗逻辑
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boldFirstTwoChars);
} else {
  boldFirstTwoChars();
}

// 监听 Resize 重新执行加粗 (防止布局变化导致换行问题)
window.addEventListener('resize', () => {
  clearTimeout(window._boldResizeTimer);
  window._boldResizeTimer = setTimeout(boldFirstTwoChars, 100);
});